import { formatCustomDate } from "../../../helpers/dateTools";
import { DEPOSIT_ACTIONS } from "./actions";

const {
  SEARCH_INPUTS,
  SELECT_INPUTS,
  GET_DEPOSITS,
  ADD_DEPOSIT,
  EDIT_DEPOSIT,
  DELETE_DEPOSIT,
} = DEPOSIT_ACTIONS;


const initialState = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  station: null,
  payments: [],
  bankAccounts: [],
  bankAccountsStationId: null,
  deposits: [],
};

export const depositsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_INPUTS:
      let deposits = state.deposits
      let station = state.station
      if(payload.key === 'station') {
        deposits = []
        station = payload.value
      }
      return {
        ...state,
        deposits, station,
        [payload.key]: payload.value,
      }
    case SELECT_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      }
    case GET_DEPOSITS:
      return {
      ...state,
      deposits: payload
      }
    case ADD_DEPOSIT:
      let addDeposits = [...state.deposits]  
      if(payload.idStation === state?.station?.id) {
        addDeposits = [payload, ...addDeposits]
      }
      return {
        ...state,
        deposits: addDeposits
      }
    case EDIT_DEPOSIT:
      const editDeposits = [...state.deposits]
      const idx = editDeposits.findIndex(deposit => deposit.id === payload.id)
      editDeposits[idx] = {...editDeposits[idx], ...payload}
      return {
        ...state,
        deposits: editDeposits
      }
    case DELETE_DEPOSIT:
      return {
        ...state,
        deposits: state.deposits.filter(deposit => deposit.id !== payload)
      }
    default:
      return state;
  }
}